import { BaseClient } from '~client/base-client';
import { ClientConfig } from '~client/client-config';
import { AdminClientController } from '~client/controller/admin-client-controller';
import { AdminController } from '~client/controller/admin-controller';
import { AdminSponsorController } from '~client/controller/admin-sponsor-controller';
import { ClientUserController } from '~client/controller/client-user-controller';
import { EventAdminController } from '~client/controller/event-admin-controller';
import { LocationProfileAdminController } from '~client/controller/location-profile-admin-controller';
import { MarketplaceAdminController } from '~client/controller/marketplace-admin-controller';
import { MediaAdminController } from '~client/controller/media-admin-controller';

/*
 * Docs: https://api.dev.yoop.app/swagger-ui.html
 */
export class ApiClient extends BaseClient {
  adminClientController: AdminClientController;
  adminController: AdminController;
  adminSponsorController: AdminSponsorController;
  clientUserController: ClientUserController;
  eventAdminController: EventAdminController;
  locationProfileAdminController: LocationProfileAdminController;
  marketplaceAdminController: MarketplaceAdminController;
  mediaAdminController: MediaAdminController;

  constructor(config: ClientConfig) {
    super(config);

    this.adminClientController = new AdminClientController(this.api, this.config);
    this.adminController = new AdminController(this.api, this.config);
    this.adminSponsorController = new AdminSponsorController(this.api, this.config);
    this.clientUserController = new ClientUserController(this.api, this.config);
    this.eventAdminController = new EventAdminController(this.api, this.config);
    this.locationProfileAdminController = new LocationProfileAdminController(this.api, this.config);
    this.marketplaceAdminController = new MarketplaceAdminController(this.api, this.config);
    this.mediaAdminController = new MediaAdminController(this.api, this.config);
  }
}



// WEBPACK FOOTER //
// ./client/api-client.ts